import React, { useState } from 'react';

import { checkTenant } from '@libs/NwUtils';

import { useUserPermission } from '@contexts/UserContext';

import { forceReloadTravel } from '@hooks/API/Event/UseTravel';

import { EventActionsToolbar } from '@components/EventDrawer/EventDrawerUi/EventUI';
import { NwAddButton } from '@components/Gui/NwButton';
import NwUpload from '@components/Gui/NwUpload';
import AddNonBookingEventTransactionDrawer from '@components/Transactions/TransactionsDrawer/AddNonBookingEventTransactionDrawer';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const TravelActions = ({ plainMode, travelsData, onAddModels, hasBorder }) => {
    const [transactionDrawer, setTransactionDrawer] = useState(false);

    const accessAccounting = useUserPermission('AccessAccounting');

    const getUploadEndpoint = () => {
        let endpoint = `documents/upload/1?eventGroupGuid=${travelsData.GroupGuid}`;
        if (travelsData.Project) {
            endpoint = endpoint + `&projectID=${travelsData.Project.ID}`;
        }
        return endpoint;
    };

    const onAfterAddingExpense = () => {
        forceReloadTravel(travelsData.ID);
        setTransactionDrawer(false);
    };

    const isEliteBooker = checkTenant('elitemodels', true) && !accessAccounting;

    return (
        <>
            <EventActionsToolbar plainMode={plainMode} $hasBorder={hasBorder}>
                {travelsData.GroupGuid && (
                    <NwUpload
                        size="small"
                        label="add document"
                        maxSize={20}
                        showList={false}
                        types={['all']}
                        onUploadEnd={() => {
                            forceReloadTravel(travelsData.ID);
                        }}
                        endpoint={getUploadEndpoint()}
                    />
                )}
                <NwAddButton size="small" ghost onClick={onAddModels} label="add models" />
                {!travelsData.ProjectID && !isEliteBooker && (
                    <NwAddButton
                        ghost
                        onClick={() => {
                            setTransactionDrawer(true);
                        }}
                        label="add expense"
                        icon={byPrefixAndName.fass['comment-plus']}
                    />
                )}
            </EventActionsToolbar>
            {transactionDrawer && (
                <AddNonBookingEventTransactionDrawer
                    event={travelsData}
                    eventType="travel"
                    onClose={() => setTransactionDrawer(false)}
                    onSave={onAfterAddingExpense}
                />
            )}
        </>
    );
};

export default TravelActions;
